import {
	Component, OnDestroy, OnInit
}
	from '@angular/core';
import {
	Router
}
	from '@angular/router';
import {
	HeaderComponent
}
	from '../header/header.component';
import {
	FooterComponent
}
	from '../footer/footer.component';
import { NavigationEnd, RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Meta, Title } from '@angular/platform-browser';
import { MetaTagService } from '../meta-tag.service';
@
	Component({
		selector: 'app-not-found',
		standalone: true,
		imports: [HeaderComponent, FooterComponent, RouterModule],
		templateUrl: './not-found.component.html',
		styles: ``
	})
export class NotFoundComponent implements OnDestroy, OnInit {
	constructor(private router: Router, private meta: Meta,
		private titleService: Title,
		private metaService: MetaTagService
	) {
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(() => {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			});
	}
	gcroute() {
		this.router.navigate([''])
	}
	ngOnInit(): void {
		// this.metaService.updateTags("Not Found | Grammarin.com", "Not Found", "", "", "");
		this.removeMetaTags();


	}
	ngOnDestroy(): void {
		this.removeMetaTags();
	}

	private removeMetaTags() {
		const propertiesToRemove = [
			'property="og:title"',
			'property="og:description"',
			'property="og:image"',
			'property="og:url"',
			'name="twitter:image"',
			'property="og:image:alt"',
			'property="og:image:type"',
			'property="og:image:width"',
			'property="og:image:height"',
			'property="og:site_name"',
			'property="og:type"',
			'property="twitter:card"',
			'property="twitter:site"',
			'property="twitter:title"',
			'name="twitter:card"',
			'name="twitter:site"',
		];

		propertiesToRemove.forEach((selector) => this.meta.removeTag(selector));
		// console.log('Meta tags removed (destroy or reload).');
	}

}
